import axios from "axios";

function send(reqConfig, data) {
  let uri = "";
  if (reqConfig.method === "get") {
    uri = Object.keys(data).reduce((uri, key, index) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(data[key]);

      if (index === 0) {
        uri += `?${encodedKey}=${encodedValue}`;
      } else {
        uri += `&${encodedKey}=${encodedValue}`;
      }

      return uri;
    }, "");
  }

  const axiosConfig = {
    headers: {
      ...(reqConfig.token
        ? { Authorization: `Token ${reqConfig.token}` }
        : {}),
      ...reqConfig.headers,
    },
    method: reqConfig.method,
    url: reqConfig.url + uri,
    timeout: 300000,
    data: data,
    responseType: reqConfig.responseType,
  };
  if (reqConfig.validateStatus) {
    axiosConfig.validateStatus = reqConfig.validateStatus;
  }
  return axios(axiosConfig);
}

function createReqConfig(serverUrl, method, entity, token, options = {}) {
  const url = [serverUrl, entity].join("/") + "/";
  return {
    method: method,
    url: url,
    token: token,
    responseType: options.responseType,
    headers: options.headers || {},
    validateStatus: options.validateStatus,
  };
}

export default {
  send,
  createReqConfig,
};
